module.exports = __webpack_public_path__ + "static/media/times-circle-light.d6ef0535.svg";